import styled, { css } from 'styled-components'
import { NumericFormat, PatternFormat } from 'react-number-format'
import { StyledNumberFormatProps } from './types'

export const StyledNumberFormat = styled(
  ({
    error,
    canRead,
    displayType,
    formatNumber,
    ...rest
  }: StyledNumberFormatProps) => {
    if (formatNumber === undefined)
      return <NumericFormat displayType={displayType} {...rest} />
    else
      return (
        <PatternFormat
          displayType={displayType}
          {...rest}
          format={formatNumber}
        />
      )
  },
)`
  ${({ theme, error, canRead, displayType }) => css`
    color: ${theme.primaryFontColor};

    ${canRead &&
    css`
      background: ${displayType === 'text' ? 'transparent' : '#fff'} !important;
    `}

    ${error &&
    css`
      border-color: #de5447 !important;
    `}

    &&& {
      &.error {
        border-color: #de5447 !important;
      }
    }
  `}
`
